<div class="wrapper">
  <mat-card appearance="outlined">
    <mat-card-title>
      <h1 i18n>Login</h1>
    </mat-card-title>
    <mat-card-content>
      <form #loginForm="ngForm" (ngSubmit)="login()">
        <p>
          <mat-form-field>
            <span matPrefix>
              <mat-icon>person</mat-icon>
            </span>
            <input
              matInput
              required
              i18n-placeholder
              placeholder="Username or Email"
              name="identifier"
              [ngModel]="credentials().identifier"
              (ngModelChange)="updateIdentifier($event)"
              (change)="resetErrorDisplay()"
              #identifier="ngModel"
              />
              @if (identifier.hasError('required')) {
                <mat-error i18n> Username or email is required </mat-error>
              }
            </mat-form-field>
          </p>
          <p>
            <mat-form-field>
              <span matPrefix>
                <mat-icon>lock</mat-icon>
              </span>
              <input
                type="password"
                matInput
                required
                i18n-placeholder
                placeholder="Password"
                name="password"
                [ngModel]="credentials().password"
                (ngModelChange)="updatePassword($event)"
                (change)="resetErrorDisplay()"
                #password="ngModel"
                />
                @if (password.hasError('required')) {
                  <mat-error i18n> Password is required </mat-error>
                }
              </mat-form-field>
            </p>
            @if (showLoginError()) {
              <p class="login-failed-message">
                <mat-icon>warning</mat-icon>
                <strong i18n>Login failed.</strong>
              </p>
            }
            <button class="login-button" mat-raised-button [disabled]="!loginForm.valid || requestEnRoute()" i18n>Login</button>
          </form>
        </mat-card-content>
      </mat-card>
    </div>
